export enum RegulationCategory {
    // Shared categories ids 1-7
    MORTGAGE = 1,
    CASH = 2,
    SME = 3,
    // RO-specific categories (4-7)
    LEASING = 4,
    INTERNAL_CAMPAIGNS = 5,
    MARKETING = 6,
    EVENTS = 7,
    // PL-specific categories (5-11)
    CONTEST = 5,
    LENDI = 6,
    PLATFORM = 7,

    REPORTS = 8,
    INSURANCE = 10,
    LENDI_CARE = 11,
}

export class CategoryObj {
  public id!: RegulationCategory;
  public name!: string;

  constructor(categoryObj?: CategoryObj) {
    Object.assign(this, categoryObj);
  }
}

// RO-specific regulation categories (IDs 1-7)
export const RO_REGULATION_CATEGORIES = [
  RegulationCategory.MORTGAGE,
  RegulationCategory.CASH,
  RegulationCategory.SME,
  RegulationCategory.LEASING,
  RegulationCategory.INTERNAL_CAMPAIGNS,
  RegulationCategory.MARKETING,
  RegulationCategory.EVENTS,
];